module.exports = __webpack_public_path__ + "img/class3.55eca12f.webp";